import { useQuery } from '@tanstack/react-query';

import { mediaManagerClient } from '@/lib/axios';

import { LABEL_QUERY_KEYS, TLabel } from './query-keys';

type GetLabelsRequest = {
  search?: string;
};

type TGetLabelsListResponse = {
  data: TLabel[];
  total: number;
};

const getLabels = (params?: GetLabelsRequest): Promise<TGetLabelsListResponse> => {
  const queryParams: GetLabelsRequest = {};
  if (params?.search) {
    queryParams.search = params.search;
  }
  return mediaManagerClient.get('/api/v1/labels', { params: queryParams });
};

export const useGetLabels = (params?: GetLabelsRequest, options?: { enabled?: boolean }) => {
  return useQuery({
    enabled: options?.enabled,
    queryKey: [LABEL_QUERY_KEYS.LABELS, params],
    queryFn: async () => {
      const response = await getLabels(params);
      return response.data;
    },
  });
};
